"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectStatsSchema = exports.ProjectTokenContractSchema = exports.ProjectTokenSupplySchema = exports.ProjectStatValueSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.ProjectStatValueSchema = zod_1.z.object({
    currencyAmounts: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    dailyIncrement: zod_1.z.number({ required_error: 'daily increment is required' }),
    idoIncrement: zod_1.z.number({ required_error: 'ido increment is required' }).optional().nullable(),
});
exports.ProjectTokenSupplySchema = zod_1.z.object({
    max: core_contracts_ifaces_1.TokenAmountSchema,
    circulating: core_contracts_ifaces_1.TokenAmountSchema,
    burned: core_contracts_ifaces_1.TokenAmountSchema,
});
exports.ProjectTokenContractSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    address: zod_1.z.string({ required_error: 'address is required' }),
    amount: core_contracts_ifaces_1.TokenAmountSchema,
});
exports.ProjectStatsSchema = zod_1.z.object({
    price: exports.ProjectStatValueSchema,
    tvl: exports.ProjectStatValueSchema,
    marketcap: exports.ProjectStatValueSchema,
    supply: exports.ProjectTokenSupplySchema,
    contracts: zod_1.z.array(exports.ProjectTokenContractSchema),
});
